/*
  Madison Center: "Guardar para después" en el carrito (como en Amazon). Se carga en todas las páginas desde layout/theme.liquid.

  - Junto a cada "Eliminar" del carrito (página del carrito y carrito lateral) se pone un enlace "Guardar para después":
    el producto sale del carrito y pasa a la lista "Guardado para después" (sección madison-guardados, en la página del carrito).
  - Desde la lista ("Guardados para después (N)", se puede plegar): "Mover al carrito" o "Eliminar". Precio, foto y disponibilidad se leen EN VIVO de la tienda
    (/products/<producto>.js), así siempre están al día. Lo guardado no suma al total.
  - Cliente con sesión: la lista vive en su cuenta (servidor guardados-madison por /apps/guardados, firmado por Shopify),
    así la ve desde cualquier dispositivo. Sin sesión, o si el servidor no responde: se guarda en este navegador, y al
    iniciar sesión se une a la cuenta.
  - Solo se guarda variante, producto (handle), cantidad y fecha. Los textos se ponen como texto (nunca como HTML).
*/
(function () {
  var API = '/apps/guardados';
  var LOCAL = 'madison.guardados';
  var guion = document.currentScript;
  var conSesion = !!(guion && guion.dataset.cliente);
  var usarServidor = conSesion;

  // ---------- Dónde se guarda la lista ----------
  function leerLocal() {
    try {
      var lista = JSON.parse(localStorage.getItem(LOCAL) || '[]');
      return Array.isArray(lista) ? lista : [];
    } catch (e) { return []; }
  }

  function escribirLocal(lista) {
    try { localStorage.setItem(LOCAL, JSON.stringify(lista.slice(0, 100))); } catch (e) {}
  }

  function llamar(ruta, datos) {
    return fetch(API + '/' + ruta, {
      method: datos ? 'POST' : 'GET',
      headers: datos ? { 'Content-Type': 'application/json' } : {},
      body: datos ? JSON.stringify(datos) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      var tipo = r.headers.get('Content-Type') || '';
      if (!r.ok || tipo.indexOf('json') < 0) throw new Error('servidor ' + r.status);
      return r.json();
    }).then(function (json) {
      if (!Array.isArray(json.productos)) throw new Error('respuesta');
      return json.productos;
    });
  }

  // Si el servidor falla, se sigue en este navegador (nunca se pierde lo que el cliente guarda)
  function conRespaldo(promesa, local) {
    return promesa.catch(function () { usarServidor = false; return local(); });
  }

  function obtenerLista() {
    if (!usarServidor) return Promise.resolve(leerLocal());
    var pendientes = leerLocal();
    var pedido = pendientes.length
      ? llamar('unir', { productos: pendientes }).then(function (lista) { escribirLocal([]); return lista; })
      : llamar('lista');
    return conRespaldo(pedido, leerLocal);
  }

  function guardarEnLista(item) {
    function local() {
      var lista = leerLocal().filter(function (p) { return p.variante !== item.variante; });
      lista.unshift(item);
      escribirLocal(lista);
      return lista;
    }
    return usarServidor ? conRespaldo(llamar('guardar', item), local) : Promise.resolve(local());
  }

  function quitarDeLista(variante) {
    function local() {
      var lista = leerLocal().filter(function (p) { return p.variante !== variante; });
      escribirLocal(lista);
      return lista;
    }
    // Se quita también del navegador por si estaba ahí
    if (!usarServidor) return Promise.resolve(local());
    local();
    return conRespaldo(llamar('quitar', { variante: variante }), local);
  }

  // ---------- Carrito de Shopify ----------
  function carrito(ruta, datos) {
    return fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(datos),
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function refrescarCarrito() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  // ---------- Precios y productos (en vivo) ----------
  var productos = {};
  function pedirProducto(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  // Los productos agotados se sacan del canal Tienda online (35.600 al 2026-10-12), así que la web no los puede leer y se
  // muestran en gris como "Agotado Temporalmente"; al volver a tener stock se ven normales solos.
  // Si al producto le cambiaron la dirección en Shopify, la vieja ya no responde: se busca por la variante
  // (/variants/<número> lleva siempre a la dirección actual). Jonathan 2026-10-12: los productos casi nunca se borran.
  function leerProducto(handle, variante) {
    if (!productos[handle]) {
      productos[handle] = pedirProducto(handle).then(function (producto) {
        if (producto || !variante) return producto;
        return fetch('/variants/' + encodeURIComponent(variante), { method: 'HEAD', credentials: 'same-origin' })
          .then(function (r) {
            var nuevo = r.ok && (r.url.match(/\/products\/([^/?#]+)/) || [])[1];
            return nuevo && nuevo !== handle ? pedirProducto(decodeURIComponent(nuevo)) : null;
          })
          .catch(function () { return null; });
      });
    }
    return productos[handle];
  }

  function dinero(centavos) {
    var formato = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var valor = (centavos || 0) / 100;
    function miles(n, decimales, sepMiles, sepDecimal) {
      var partes = n.toFixed(decimales).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles);
      return partes.join(sepDecimal);
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      if (tipo === 'amount_no_decimals') return miles(valor, 0, ',', '.');
      if (tipo === 'amount_with_comma_separator') return miles(valor, 2, '.', ',');
      if (tipo === 'amount_no_decimals_with_comma_separator') return miles(valor, 0, '.', ',');
      return miles(valor, 2, ',', '.');
    });
  }

  // Productos que ya no existen en la tienda (borrados o sacados de la web): Shopify ya no da su nombre ni su foto.
  // Se recuerdan en este teléfono cada vez que se pueden leer, y si no, el nombre se arma con la dirección del producto
  // (ej. "heinz-colado-de-pera" → "Heinz Colado De Pera"). Pedido de Jonathan 2026-10-12.
  var CLAVE_FICHAS = 'madison-guardados-fichas';
  function leerFichas() { try { return JSON.parse(localStorage.getItem(CLAVE_FICHAS)) || {}; } catch (e) { return {}; } }
  function recordarFicha(handle, titulo, imagen) {
    var fichas = leerFichas();
    if (fichas[handle] && fichas[handle].t === titulo && fichas[handle].i === imagen) return;
    fichas[handle] = { t: titulo, i: imagen || '' };
    var claves = Object.keys(fichas);
    if (claves.length > 150) claves.slice(0, claves.length - 150).forEach(function (k) { delete fichas[k]; });
    try { localStorage.setItem(CLAVE_FICHAS, JSON.stringify(fichas)); } catch (e) {}
  }
  function nombreDeHandle(handle) {
    return String(handle || '').split('-').filter(Boolean).map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ') || 'Producto no disponible';
  }

  function foto(url, ancho) {
    if (!url) return '';
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + ancho;
  }

  // ---------- Lista "Guardado para después" ----------
  function elemento(etiqueta, clase, texto) {
    var el = document.createElement(etiqueta);
    if (clase) el.className = clase;
    if (texto != null) el.textContent = texto;
    return el;
  }

  function avisar(texto) {
    var aviso = caja && caja.querySelector('[data-madison-guardados-aviso]');
    if (aviso) { aviso.textContent = texto; aviso.hidden = !texto; }
  }

  function dibujar(lista) {
    colocarLista();
    if (!caja) return;
    var contenedor = caja.querySelector('[data-madison-guardados-lista]');
    var cuenta = caja.querySelector('[data-madison-guardados-cuenta]');
    var invitacion = caja.querySelector('[data-madison-guardados-sesion]');
    caja.hidden = lista.length === 0;
    if (cuenta) cuenta.textContent = '(' + lista.length + ')';
    if (invitacion) invitacion.hidden = conSesion;

    Promise.all(lista.map(function (item) { return leerProducto(item.producto, item.variante); })).then(function (datos) {
      contenedor.textContent = '';
      lista.forEach(function (item, i) {
        var producto = datos[i];
        var variante = producto && producto.variants.filter(function (v) { return String(v.id) === item.variante; })[0];
        contenedor.appendChild(fila(item, producto, variante));
      });
    });
  }

  function fila(item, producto, variante) {
    var el = elemento('div', 'madison-guardado');
    var enlace = producto ? producto.url + (variante ? '?variant=' + variante.id : '') : null;

    var imagen = elemento('a', 'madison-guardado__foto');
    var src = variante && variante.featured_image ? variante.featured_image.src : producto && producto.featured_image;
    var ficha = !producto ? (item.titulo ? { t: item.titulo, i: item.imagen } : leerFichas()[item.producto]) : null;
    if (producto) recordarFicha(item.producto, producto.title, producto.featured_image);
    else {
      // Ya no existe en la tienda: foto en gris (si se recuerda), su nombre y nada se puede tocar, solo "Eliminar"
      el.className += ' madison-guardado--no-existe';
      imagen = elemento('span', 'madison-guardado__foto');
      src = ficha && ficha.i;
    }
    if (enlace) imagen.href = enlace;
    if (src) {
      var img = document.createElement('img');
      img.src = foto(src, 200);
      img.alt = '';
      img.loading = 'lazy';
      imagen.appendChild(img);
    }
    el.appendChild(imagen);

    var info = elemento('div', 'madison-guardado__info');
    var titulo = elemento(enlace ? 'a' : 'span', 'madison-guardado__titulo link text--strong',
      producto ? producto.title + (variante && producto.variants.length > 1 ? ' – ' + variante.title : '') : (ficha && ficha.t) || nombreDeHandle(item.producto));
    if (enlace) titulo.href = enlace;
    info.appendChild(titulo);

    var disponible = !!(variante && variante.available);
    // Agotado: foto original con un velo gris encima, como en la app (Jonathan 2026-10-20)
    if (!disponible) el.className += ' madison-guardado--agotado';
    if (variante) {
      var precios = elemento('div', 'madison-guardado__precios');
      precios.appendChild(elemento('span', 'madison-guardado__precio' + (variante.compare_at_price > variante.price ? ' madison-guardado__precio--oferta' : ''), dinero(variante.price)));
      if (variante.compare_at_price > variante.price) precios.appendChild(elemento('s', 'madison-guardado__antes', dinero(variante.compare_at_price)));
      info.appendChild(precios);
    }
    if (!disponible) info.appendChild(elemento('span', 'madison-guardado__agotado', 'Agotado Temporalmente'));
    el.appendChild(info);

    // Botones a la derecha: "Mover al carrito" y, debajo, "Eliminar"
    var acciones = elemento('div', 'madison-guardado__acciones');
    var mover = elemento('button', 'button button--primary button--small madison-guardado__mover', 'Mover al carrito');
    mover.type = 'button';
    mover.disabled = !disponible;
    mover.addEventListener('click', function () { moverAlCarrito(item, mover); });
    var eliminar = elemento('button', 'link madison-guardado__eliminar', 'Eliminar');
    eliminar.type = 'button';
    eliminar.addEventListener('click', function () {
      eliminar.disabled = true;
      quitarDeLista(item.variante).then(dibujar);
    });
    acciones.appendChild(mover);
    acciones.appendChild(eliminar);
    el.appendChild(acciones);
    return el;
  }

  function moverAlCarrito(item, boton) {
    boton.disabled = true;
    avisar('');
    carrito('/cart/add.js', { items: [{ id: Number(item.variante), quantity: item.cantidad || 1 }] })
      .then(function () { return quitarDeLista(item.variante); })
      .then(function (lista) { dibujar(lista); refrescarCarrito(); })
      .catch(function (error) {
        boton.disabled = false;
        avisar((error && error.description) || 'No se pudo mover al carrito. Intenta de nuevo.');
      });
  }

  // ---------- "Guardar para después" en cada producto del carrito ----------
  // El enlace se pone junto a cada "Eliminar" del carrito (página y carrito lateral) con los datos de /cart.js,
  // así no hay que modificar main-cart.liquid ni mini-cart.liquid. Se vuelve a poner cuando el tema redibuja el carrito.
  var ELIMINAR = 'a[data-action="decrease-quantity"][data-quantity="0"][data-line]';
  var poniendo = null;
  function ponerEnlaces() {
    if (poniendo || !document.querySelector(ELIMINAR + ':not([data-madison-con-guardar])')) return;
    poniendo = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (carritoActual) {
        Array.prototype.forEach.call(document.querySelectorAll(ELIMINAR + ':not([data-madison-con-guardar])'), function (eliminar) {
          var item = carritoActual.items[parseInt(eliminar.dataset.line, 10) - 1];
          eliminar.setAttribute('data-madison-con-guardar', '');
          // Regalos y productos gratis (envoltura, obsequios) no se guardan
          if (!item || !item.handle || item.final_price === 0) return;
          var enlace = elemento('a', 'madison-guardar link', 'Guardar para después');
          enlace.href = '#guardados';
          enlace.setAttribute('data-madison-guardar', '');
          enlace.dataset.clave = item.key;
          enlace.dataset.variante = String(item.variant_id);
          enlace.dataset.producto = item.handle;
          enlace.dataset.cantidad = String(item.quantity);
          // Nombre y foto: se guardan para mostrarlo en gris si luego se agota y sale de la web (Jonathan 2026-10-12)
          enlace.dataset.titulo = item.product_title || '';
          enlace.dataset.imagen = (item.featured_image && item.featured_image.url) || item.image || '';
          eliminar.insertAdjacentElement('afterend', enlace);
        });
      })
      .catch(function () {})
      .then(function () { poniendo = null; ponerEnlaces(); });
  }
  // La lista va justo debajo de los productos del carrito (como Amazon), antes de "¡Completa tu compra!", que el tema
  // dibuja dentro de su sección del carrito. Si el tema redibuja el carrito, la lista (la misma, con su contenido) se vuelve
  // a poner en su sitio; si no hay sugeridos (carrito vacío), vuelve a su propia sección.
  var caja = null;
  var casa = null;
  function colocarLista() {
    caja = caja || document.querySelector('[data-madison-guardados]');
    if (!caja) return;
    casa = casa || caja.parentNode;
    var sugeridos = document.querySelector('.cart-wrapper [data-section-id$="-upsell"]');
    var destino = sugeridos && sugeridos.closest('.container');
    if (destino && destino !== caja) {
      if (caja.nextElementSibling !== destino) destino.parentNode.insertBefore(caja, destino);
    } else if (!caja.isConnected && casa) {
      casa.appendChild(caja);
    }
  }

  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      if (cambios[i].addedNodes.length || cambios[i].removedNodes.length) { colocarLista(); ponerEnlaces(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest('[data-madison-guardar]');
    if (!enlace) return;
    e.preventDefault();
    e.stopPropagation();
    if (enlace.getAttribute('aria-disabled') === 'true') return;
    enlace.setAttribute('aria-disabled', 'true');
    var item = {
      variante: String(enlace.dataset.variante),
      producto: enlace.dataset.producto,
      cantidad: parseInt(enlace.dataset.cantidad, 10) || 1,
      fecha: new Date().toISOString()
    };
    if (enlace.dataset.titulo) item.titulo = enlace.dataset.titulo;
    if (enlace.dataset.imagen) item.imagen = enlace.dataset.imagen;
    guardarEnLista(item)
      .then(function (lista) {
        return carrito('/cart/change.js', { id: enlace.dataset.clave, quantity: 0 }).then(function () {
          dibujar(lista);
          refrescarCarrito();
          mensaje('Guardado para después. Lo verás en tu carrito.');
        });
      })
      .catch(function () {
        enlace.removeAttribute('aria-disabled');
        mensaje('No se pudo guardar. Intenta de nuevo.');
      });
  }, true);

  // Aviso pequeño abajo de la pantalla
  function mensaje(texto) {
    var el = document.querySelector('.madison-guardados-mensaje');
    if (!el) {
      el = elemento('div', 'madison-guardados-mensaje');
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = texto;
    el.classList.add('is-visible');
    clearTimeout(el._ocultar);
    el._ocultar = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  }

  // La flechita de "Guardados para después" pliega o despliega la lista
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-madison-guardados-plegar]');
    if (!boton || !caja) return;
    var plegado = caja.classList.toggle('is-plegado');
    boton.setAttribute('aria-expanded', plegado ? 'false' : 'true');
  });

  // ---------- Inicio ----------
  function iniciar() {
    ponerEnlaces();
    colocarLista();
    if (caja) obtenerLista().then(dibujar);
    else if (usarServidor && leerLocal().length) obtenerLista(); // al iniciar sesión, une lo del navegador a la cuenta
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
